export default function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/defineProperty.js
// module id = 45
// module chunks = 0